import { css } from 'emotion';
import { fontFamily, breakpoints } from '@joykit/variables';

const getBreakpoints = () => ({
  [`@media(max-width: ${breakpoints.medium - 1}px)`]: {
    maxWidth: '100vw'
  },
  [`@media(min-width: ${breakpoints.medium}px)`]: {
    maxWidth: '100vw'
  },
  [`@media(min-width: ${breakpoints.large}px)`]: {
    maxWidth: '100vw'
  },
  [`@media(min-width: ${breakpoints.extraLarge}px)`]: {
    maxWidth: '100vw'
  }
});

export namespace styles {
  export const container = () => {
    const mediaQueries = getBreakpoints();
    return css({
      fontFamily,
      opacity: 1,
      transform: 'scale(1.0)',
      width: '100vw',
      height: '100vh',
      zIndex: 1500,
      position: 'relative',
      boxShadow: 'rgba(0, 0, 0, 0.25) 0px 14px 45px, rgba(0, 0, 0, 0.22) 0px 10px 18px',
      borderRadius: 0,
      backgroundColor: '#fff',
      top: '0px',
      left: '0px',
      overflow: 'scroll',
      ...mediaQueries
    });
  };
}
